import toPrecision from './toPrecision';
import { Language } from './language';

const formatValue = (scale: number, locale: string = Language.DEFAULT) => (value: number) =>
  toPrecision(value, scale).toLocaleString(locale, {minimumFractionDigits: scale, maximumFractionDigits: scale});

export default formatValue;
